import { render, staticRenderFns } from "./Afterpay.vue?vue&type=template&id=bf3203c0&scoped=true&"
import script from "./Afterpay.vue?vue&type=script&lang=js&"
export * from "./Afterpay.vue?vue&type=script&lang=js&"
import style0 from "./Afterpay.vue?vue&type=style&index=0&id=bf3203c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3203c0",
  null
  
)

export default component.exports